import moment from 'moment';
import { payment, term } from '../../../util/formula';
import { currency, formatDate } from '../../../util/format';
import { GETTERS } from '../../../storeConstants';
import { roundCurrency } from "../../../util/bankersRound";


export default {
  [GETTERS.FORMATED_BREAKDOWN_PAYMENT](state, getters) {
    return currency(roundCurrency(
      getters.PAYMENT
      + state.EXTRA_MONTHLY_PAYMENT_AMOUNT
      + state.HOA_FEES
      + state.INSURANCE_COST
      + state.PROPERTY_TAX), true, '$0,0');
  },
  [GETTERS.FORMATED_INSURANCE_COST](state) {
    return currency(roundCurrency(state.INSURANCE_COST), false, '$0,0.00');
  },
  [GETTERS.FORMATED_HOA](state) {
    return currency(roundCurrency(state.HOA_FEES), false, '$0,0.00');
  },
  [GETTERS.FORMATED_PROPERTY_TAX](state) {
    return currency(roundCurrency(state.PROPERTY_TAX), false, '$0,0.00');
  },
  [GETTERS.MODIFIED_PRINCIPLE](state) {
    return state.PRINCIPLE - (state.ANNUAL_PAYMENT_AMOUNT);
  },
  [GETTERS.TERM_TEST](state, getters) {
    return term({ ...state, PAYMENT: getters.PAYMENT });
  },
  [GETTERS.PAYOFF_DATE](state, getters) {
    const startDate = moment(state.START_DATE);
    return formatDate(startDate.add(getters.MODIFIED_TERM - 1, 'months'), "MMM DD, YYYY");
  },
  [GETTERS.INTERVAL_LENGTH_MONTHS](state, getters) {
    return getters.MODIFIED_TERM / state.INTERVAL;
  },
  [GETTERS.DOWNPAYMENT_PERCENTAGE](state) {
    return Math.round(state.DOWNPAYMENT / state.PRINCIPLE * 1000) / 10;
  },
  [GETTERS.INTEREST_PERCENTAGE](state) {
    if (state.INTEREST_RATE < 0) return '';
    return state.INTEREST_RATE * 100;
  },
  [GETTERS.TERM_YEARS](state, getters) {
    return Math.round(getters.MODIFIED_TERM / 12);
  },
  [GETTERS.PAYMENT](state) {
    return payment({ ...state });
  },
  [GETTERS.FORMATED_PAYMENT](state, getters) {
    if (Object.keys(state.ERRORS).length > 0) return 'N/A';
    return currency(roundCurrency(getters.PAYMENT), true, '$0,0');
  },
  [GETTERS.FORMATED_PAYMENT_AND_EXTRA](state, getters) {
    return currency(roundCurrency(getters.PAYMENT + state.EXTRA_MONTHLY_PAYMENT_AMOUNT), true, '$0,0');
  },
  [GETTERS.MODIFIED_TERM](state) {
    return state.TERM - state.MODIFY_TERM;
  },
  [GETTERS.FORMATED_PRINCIPLE](state) {
    return currency(roundCurrency(state.PRINCIPLE), false, '$0,0');
  },
  [GETTERS.FORMATED_DOWNPAYMENT](state) {
    return currency(roundCurrency(state.DOWNPAYMENT), false, '$0,0');
  },
  [GETTERS.FORMATED_START_DATE](state) {
    return formatDate(state.START_DATE, 'M/D/YYYY');
  },

  [GETTERS.FORMATED_EXTRA_PAYMENT](state) {
    return currency(roundCurrency(state.EXTRA_MONTHLY_PAYMENT_AMOUNT), false);
  },
  [GETTERS.FORMATED_ANNUAL_PAYMENT_AMOUNT](state) {
    return currency(roundCurrency(state.ANNUAL_PAYMENT_AMOUNT), false);
  },
  [GETTERS.FORMATED_ANNUAL_PAYMENT_DATE](state) {
    return state.ANNUAL_PAYMENT_DATE;
  },
  [GETTERS.FORMATED_ONE_TIME_PAYMENT_AMOUNT](state) {
    return currency(roundCurrency(state.ONE_TIME_PAYMENT_AMOUNT), false);
  },
  [GETTERS.FORMATED_ONE_TIME_PAYMENT_DATE](state) {
    return formatDate(state.ONE_TIME_PAYMENT_DATE, 'M/D/YYYY');
  },
};


